import api from "../config/api";

export async function getValidaCNPJ(CNPJ) {
  try {
    var retorno = await api.get(`Dominio/ValidarCnpj?cnpj=${CNPJ}`).then((response) => {
      if (response.data.Erros.length > 0)
        return { validate: false, mensagem: response.data.Mensagem };
      else return { validate: true, mensagem: "" };
    });
    return retorno;
  } catch (error) {
    return { validate: false, mensagem: `${error.Message}` };
  }
};
